import { gql } from "@apollo/client";

export const META = gql`
  query meta(
    $project_id: ID!
    $tenantID: ID!
    $env: String
    $hiddenMetrics: Boolean
    $hiddenDimensions: Boolean
    $from: String
    $to: String
  ) {
    meta(
      project_id: $project_id
      tenantID: $tenantID
      env: $env
      hiddenMetrics: $hiddenMetrics
      hiddenDimensions: $hiddenDimensions
      from: $from
      to: $to
    ) {
      id
      name
      friendlyName
      valueType
      category {
        friendlyName
      }
    }
    projects(tenantID: $tenantID) {
      id
      title
    }
  }
`;

export const META_DIMENSIONS = gql`
  query meta(
    $project_id: ID!
    $tenantID: ID!
    $metricIds: [ID!]
    $env: String
    $hiddenMetrics: Boolean
    $hiddenDimensions: Boolean
  ) {
    meta(
      project_id: $project_id
      metricIds: $metricIds
      dimensions: true
      tenantID: $tenantID
      env: $env
      hiddenMetrics: $hiddenMetrics
      hiddenDimensions: $hiddenDimensions
    ) {
      id
      dimensionId: id
      name
      friendlyName
      isFilterable
      isGroupable
      valueType
    }
  }
`;

export const META_DIMENSIONS_ITEMS = gql`
  query meta(
    $project_id: ID!
    $tenantID: ID!
    $metricIds: [ID!]
    $dimensionId: ID!
    $env: String
    $hiddenMetrics: Boolean
    $hiddenDimensions: Boolean
    $from: String
    $to: String
  ) {
    meta(
      tenantID: $tenantID
      project_id: $project_id
      metricIds: $metricIds
      dimensionId: $dimensionId
      dimensionItems: true
      env: $env
      hiddenMetrics: $hiddenMetrics
      hiddenDimensions: $hiddenDimensions
      from: $from
      to: $to
      limit: 1500
    ) {
      id
      name
      friendlyName
    }
  }
`;

export const META_DIMENSIONS_ITEMS_SEARCH = gql`
  query meta(
    $project_id: ID!
    $tenantID: ID!
    $metricIds: [ID!]
    $dimensionId: ID!
    $dimension_item_input_text: String
    $env: String
    $hiddenMetrics: Boolean
    $hiddenDimensions: Boolean
    $limit: Int
    $from: String
    $to: String
  ) {
    meta(
      tenantID: $tenantID
      project_id: $project_id
      metricIds: $metricIds
      dimensionId: $dimensionId
      dimensionItems: true
      dimension_item_input_text: $dimension_item_input_text
      env: $env
      hiddenMetrics: $hiddenMetrics
      hiddenDimensions: $hiddenDimensions
      limit: $limit
      from: $from
      to: $to
    ) {
      id
      name
      friendlyName
    }
  }
`;

export const GRANULARITY = gql`
  query meta(
    $project_id: ID!
    $tenantID: ID!
    $metricIds: [ID!]
    $env: String
    $hiddenMetrics: Boolean
    $hiddenDimensions: Boolean
  ) {
    meta(
      project_id: $project_id
      metricIds: $metricIds
      granularities: true
      tenantID: $tenantID
      env: $env
      hiddenMetrics: $hiddenMetrics
      hiddenDimensions: $hiddenDimensions
    ) {
      id
      value: name
      label: friendlyName
    }
  }
`;

/**
 * Mutation used to save a new query
 */
export const CREATE_NAMED_QUERY = gql`
  mutation createNamedQuery($input: NamedQueryInput!) {
    createNamedQuery(input: $input) {
      id
      query
      name
      private
      author {
        email
      }
    }
  }
`;

/**
 * Mutation used to save an existing query
 */
export const UPDATE_NAMED_QUERY = gql`
  mutation updateNamedQuery($id: ID!, $input: NamedQueryInput!) {
    updateNamedQuery(id: $id, input: $input) {
      id
      query
      name
      private
      author {
        email
      }
    }
  }
`;

/**
 * Mutation to delete an existing query
 */
export const DELETE_NAMED_QUERY = gql`
  mutation deleteNamedQuery($id: ID!, $tenantID: ID!) {
    deleteNamedQuery(id: $id, tenantID: $tenantID)
  }
`;

export const LIST_SAVED_QUERIES = gql`
  query projects($tenantID: ID!) {
    projects(tenantID: $tenantID) {
      id
      namedQueries {
        id
        query
        name
        private
        author {
          firstName
          lastName
          email
        }
        updatedAt
      }
    }
  }
`;

export const SAVE_QUERY = gql`
  mutation saveQuery(
    $tenantID: ID!
    $query: String!
    $name: String
    $projectID: ID
    $originalQuery: String!
  ) {
    saveQuery(
      tenantID: $tenantID
      query: $query
      name: $name
      projectID: $projectID
      originalQuery: $originalQuery
    )
  }
`;

export const LOAD_QUERY = gql`
  query loadQuery($tenantID: ID!, $queryID: String!) {
    loadQuery(tenantID: $tenantID, queryID: $queryID) {
      query
    }
  }
`;

export const CUSTOM_DATE_RANGES = gql`
  query ($tenantID: ID!) {
    timeRanges(tenantID: $tenantID) {
      id
      name
      slug
      from
      to
      position
    }
  }
`;
